import React, { useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./PrivacyPolicy.css";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

export default function PrivacyPolicy() {
    const { t, i18n } = useTranslation();
    const meta = useMemo(() => t("privacy.meta", { returnObjects: true }), [t, i18n.language]);
    const hero = useMemo(() => t("privacy.hero", { returnObjects: true }), [t, i18n.language]);
    const sections = useMemo(() => {
        const data = t("privacy.sections", { returnObjects: true });
        return Array.isArray(data) ? data : [];
    }, [t, i18n.language]);
    const contact = useMemo(() => t("privacy.contact", { returnObjects: true }), [t, i18n.language]);
    const brand = t("common.brand");
    const metaTitle = (meta && meta.title) || "";

    useEffect(() => {
        const previousTitle = document.title;
        if (metaTitle) {
            document.title = `${metaTitle} | ${brand}`;
        }

        return () => {
            document.title = previousTitle;
        };
    }, [metaTitle, brand]);

    return (
        <>
            <SiteHeader />
            <main className="privacy-page">
                <div className="privacy-container">
                    <header className="privacy-hero">
                        <span className="privacy-meta-label">
                            {meta && meta.lastUpdatedLabel}: {meta && meta.lastUpdatedDate}
                        </span>
                        <h1 className="privacy-hero__title">{hero && hero.heading}</h1>
                        <p className="privacy-hero__summary">{hero && hero.summary}</p>
                    </header>

                    <section className="privacy-sections">
                        {sections.map((section) => (
                            <article key={section.key} className="privacy-section">
                                <h2 className="privacy-section__title">{section.heading}</h2>
                                <div className="privacy-section__body">
                                    {Array.isArray(section.paragraphs) &&
                                        section.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}

                                    {Array.isArray(section.bullets) && section.bullets.length > 0 && (
                                        <div className="privacy-section__list">
                                            {section.bulletsHeading && <h3>{section.bulletsHeading}</h3>}
                                            <ul>
                                                {section.bullets.map((item, itemIndex) => (
                                                    <li key={itemIndex}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </article>
                        ))}
                    </section>

                    <section className="privacy-contact">
                        <h2>{contact && contact.heading}</h2>
                        {Array.isArray(contact && contact.paragraphs) &&
                            contact.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
                        {contact && contact.email && (
                            <p className="privacy-contact__email">
                                <span>{contact.emailLabel}</span>
                                <a href={`mailto:${contact.email}`}>{contact.email}</a>
                            </p>
                        )}
                    </section>
                </div>
            </main>
            <SiteFooter />
        </>
    );
}
